module.exports = __webpack_public_path__ + "img/1.a455a616.jpg";